<template>
  <el-dialog :visible.sync="dialogVisible" width="90%" custom-class="custom-dialog" append-to-body :close-on-click-modal="false" :close-on-press-escape="false">
    <div slot="title" class="title">
      <div class="title-name">{{ dialogTitle }}</div>
      <div class="side-title"></div>
      <div class="dialog-close-btn" @click="close">X</div>
    </div>
    <div class="edit-dialog-part">
      <div class="part-left">
        <div class="dialog-content">
          <p style="color: #2e86c5;"><i class="el-icon-warning mr10"></i>您可以输入任意相关信息，不会直接改变当前数据，放心大胆儿地写，收到反馈后我们将对数据第一时间进行处理</p>
          <el-input v-model="feedback" type="textarea" :autosize="{ minRows: 18, maxRows: 18 }" placeholder="可以输入跟当前公司有关的任何信息" style="margin: 10px 10px 0px;"></el-input>
        </div>
      </div>
      <div class="part-right">
        <FeedbackRemark ref="FeedbackRemark" :cid="cid" :feedback-type="feedbackType"></FeedbackRemark>
      </div>
    </div>
    <div slot="footer">
      <el-row type="flex" align="center" justify="center">
        <button class="alpha-btn mr10" @click="close">取消</button>
        <button class="alpha-btn-primary" @click="confirm">保存</button>
      </el-row>
    </div>
  </el-dialog>
</template>
<script>
import FeedbackRemark from './FeedbackRemark.vue'

export default {
  components: { FeedbackRemark },
  data() {
    return {
      dialogVisible:false,
      dialogTitle: '',
      feedback: '',
      feedbackType: '',
      cid: '',
    }
  },
  methods: {
    open({cid,type,title}){
      this.dialogTitle = title || '反馈'
      this.cid = cid
      this.feedbackType = type
      this.feedback = ''
      this.dialogVisible = true
      this.$nextTick(_=>{
        this.$refs.FeedbackRemark.loadData()
      })
    },
    close(){
      this.dialogVisible = false
    },
    async confirm(){
      if(this.saving) return this.$message.warning('保存中，请稍候')
      this.saving = true
      const res = await app.service('company').addCompanyRemark({
        cid: this.cid,
        remark: { user: app.user.account, content: this.feedback, feedbackType: this.feedbackType, },
        type: '反馈',
      })
      if (res.status === 'success') {
        this.$message.success('反馈已收到')
        this.dialogVisible = false
        this.$emit('addFeedback')
      } else this.$message.error(res.msg)
      this.saving = false
    },
    // async confirm(){
    //   if(this.saving) return this.$message.warning('保存中，请稍候')
    //   this.saving = true
    //   const res = await app.service('company').addCompanyFieldFeedback({
    //     cid: this.cid,
    //     feedbackType: this.feedbackType,
    //     content: this.feedback,
    //   })
    //   if (res.status === 'success') {
    //     this.$message.success('反馈已收到')
    //     this.dialogVisible = false
    //   } else this.$message.error(res.msg)
    //   this.saving = false
    // },
  },
}
</script>
<style scoped src="../../../statistics/css/companyV2common.css" ></style>
<style src="../../../statistics/css/common.css" scoped></style>
<style scoped>
.dialog-content{
  padding: 0 30px;
}
.edit-dialog-part{
  display: flex;
}
.edit-dialog-part .part-left{
  flex: auto;
}
.edit-dialog-part .part-right{
  flex: none;
  width: 260px;
}
</style>
